export const MANAGE_PORTAL_PATH = '/manage/#';

export const redirectToManagePortal = () => {
    window.location.replace(MANAGE_PORTAL_PATH);
};
